import React from "react";
import { Link } from "react-router-dom";
import { Check, MapPin, ArrowRight } from "lucide-react";
import { newToTexas, images } from "../mock";
import PageHero from "../components/PageHero";
import { PropertySearch } from "../components/Sections";
import { Button } from "../components/ui/button";

const areaImages = [
  images.heroExteriors[1],
  images.heroExteriors[2],
  images.interiors[0],
  images.interiors[1],
];

const NewToTexas = () => {
  return (
    <div>
      <PageHero
        eyebrow="Welcome, Y'all"
        title="New to Texas?"
        subtitle={newToTexas.intro}
        image={images.heroExteriors[2]}
      />

      {/* Perks */}
      <section className="max-w-7xl mx-auto px-6 md:px-8 py-24">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <span className="text-xs tracking-luxury uppercase text-gold">Why the Corridor</span>
            <h2 className="font-display text-4xl md:text-5xl text-[#141210] mt-4 mb-8 leading-tight">
              Room to breathe, and a warm welcome.
            </h2>
            <ul className="space-y-4">
              {newToTexas.perks.map((perk) => (
                <li key={perk} className="flex items-start gap-4">
                  <span className="mt-0.5 w-6 h-6 rounded-full bg-[#f7edcf] flex items-center justify-center shrink-0">
                    <Check className="w-3.5 h-3.5 text-gold" />
                  </span>
                  <span className="text-[#4a423a] text-lg">{perk}</span>
                </li>
              ))}
            </ul>
            <p className="text-[#5c5348] leading-relaxed mt-8">
              Relocating is a big leap — especially for military families arriving at JBSA or Randolph.
              I make the landing soft: neighborhood tours, school insights, and a lender who understands
              your PCS timeline.
            </p>
          </div>
          <div className="img-zoom rounded-3xl overflow-hidden shadow-[0_30px_70px_-40px_rgba(84,64,34,0.5)]">
            <img
              src={images.veteranFamily[2]}
              alt="Family relocating to Texas"
              className="w-full h-[520px] object-cover"
            />
          </div>
        </div>
      </section>

      {/* Areas */}
      <section className="bg-[#f4f1ea]">
        <div className="max-w-7xl mx-auto px-6 md:px-8 py-24">
          <div className="text-center max-w-2xl mx-auto mb-14">
            <span className="text-xs tracking-luxury uppercase text-gold">Where to Land</span>
            <h2 className="font-display text-4xl md:text-5xl text-[#141210] mt-4">
              Corridor communities to love
            </h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {newToTexas.areas.map((a, i) => (
              <div
                key={a.name}
                className="bg-white rounded-3xl overflow-hidden border border-[#efe6d6] hover-lift group"
              >
                <div className="img-zoom h-56">
                  <img src={areaImages[i]} alt={a.name} className="w-full h-full object-cover" />
                </div>
                <div className="p-7">
                  <div className="flex items-center gap-2 mb-2">
                    <MapPin className="w-4 h-4 text-gold" />
                    <h3 className="font-display text-2xl text-[#141210]">{a.name}</h3>
                  </div>
                  <p className="text-sm text-[#5c5348] leading-relaxed">{a.blurb}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Property search */}
      <section className="max-w-7xl mx-auto px-6 md:px-8 py-24">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <span className="text-xs tracking-luxury uppercase text-gold">Start Browsing</span>
          <h2 className="font-display text-4xl md:text-5xl text-[#141210] mt-4">
            Find homes by area
          </h2>
        </div>
        <PropertySearch />
        <div className="text-center mt-14">
          <Link to="/apply-to-buy">
            <Button className="bg-[#d4af37] hover:bg-[#c19a2e] text-white rounded-full px-9 h-13 py-6 tracking-luxury uppercase text-xs">
              Plan Your Move <ArrowRight className="w-4 h-4 ml-2" />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default NewToTexas;
